import { motion } from "framer-motion";
import { useLanguage } from "../../context/LanguageContext";

export const Fleet = () => {
  const { t } = useLanguage();
  return (
    <section id="fleet" data-testid="fleet-section" className="py-28 md:py-36 border-y border-white/10 bg-[#0F172A]/40">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <p className="font-mono-tech text-xs tracking-[0.25em] uppercase text-[#60A5FA] mb-6" data-testid="fleet-overline">
            {t.fleet.overline}
          </p>
          <h2 className="font-display font-bold tracking-tight leading-[1.05] text-4xl md:text-5xl lg:text-6xl max-w-3xl" data-testid="fleet-title">
            {t.fleet.title}
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {t.fleet.groups.map((g, i) => (
            <motion.div
              key={g.maker}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`fleet-card-${g.maker.toLowerCase()}`}
              className="group rounded-xl border border-white/10 bg-[#020617] p-6 transition-all duration-500 hover:border-[#2563EB]/60 hover:-translate-y-1"
            >
              <div className="font-mono-tech text-[10px] text-slate-500 mb-2">{String(i + 1).padStart(2, "0")}</div>
              <h3 className="font-display font-bold text-2xl tracking-tight mb-5 group-hover:text-[#60A5FA] transition-colors duration-300">
                {g.maker}
              </h3>
              <div className="flex flex-wrap gap-2">
                {g.models.map((m) => (
                  <span key={m} className="font-mono-tech text-xs px-2.5 py-1.5 rounded bg-[#0F172A] border border-white/10 text-slate-300">
                    {m}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
